import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Planning my training sessions used to take me hours every week. Now I simply open the system, choose the protocol, and work. My clients are seeing results faster than ever — and they keep coming back.',
  author: 'Jennifer M.',
  role: 'Certified Dog Trainer',
  location: 'Florida, USA'
}, {
  text: 'The Training Technique Library alone is worth the price. Everything is organized by behavior type and ready to implement immediately. I use it every single day.',
  author: 'Michael R.',
  role: 'Canine Behavior Consultant',
  location: 'Texas, USA'
}, {
  text: 'I work with reactive dogs every week and this system finally gave me a framework I can rely on for every case — regardless of the reactivity type or the breed. It has completely changed how I approach my sessions.',
  author: 'Sarah T.',
  role: 'Dog Training Studio Owner',
  location: 'Ontario, Canada'
}, {
  text: 'The Ready-To-Use Protocols saved me countless hours of preparation. The counter-conditioning frameworks alone are worth ten times the price. I wish I had found this in my first year of training.',
  author: 'David L.',
  role: 'Dog Trainer & Behavior Specialist',
  location: 'Melbourne, Australia'
}, {
  text: 'My rescue would lunge and bark at every dog on our walks and I was at my breaking point. Following the reactive dog protocols step by step, we hit our first calm walk in three weeks. I finally feel like I understand my own dog.',
  author: 'Karen W.',
  role: 'Reactive Dog Owner',
  location: 'Colorado, USA'
}];
export function Testimonials() {
  return <section className="py-7 px-4 sm:px-6 bg-white border-y-2 border-brand-brown/15" data-id="element-154">
      <div className="text-center mb-5" data-id="element-155">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-green mb-2 uppercase leading-tight" data-id="element-156">
          WHAT OTHER PROFESSIONALS ARE SAYING
        </h2>
        <p className="text-sm font-bold text-brand-brown uppercase tracking-wide" data-id="element-157">
          Testimonials from dog trainers and reactive dog owners
        </p>
      </div>

      <div className="flex flex-col gap-3.5" data-id="element-158">
        {testimonials.map((t, i) => <div key={i} className="bg-brand-beige border border-brand-brown/15 p-4 rounded-md shadow-sm" data-id="element-159">
            <div className="flex gap-1 mb-2" data-id="element-160">
              {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-161" />)}
            </div>
            <p className="text-brand-ink font-medium mb-3 leading-snug text-sm italic" data-id="element-162">
              "{t.text}"
            </p>
            <div className="border-t border-brand-brown/15 pt-3 flex items-center gap-3" data-id="element-163">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-bold text-sm border border-brand-green/30" data-id="element-164">
                {t.author.charAt(0)}
              </div>
              <div className="leading-none" data-id="element-165">
                <p className="font-bold text-brand-green text-sm mb-1" data-id="element-166">
                  — {t.author}
                </p>
                <p className="text-[10px] text-brand-ink/60 font-bold uppercase tracking-wide" data-id="element-167">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}